import React from 'react';
import { useQueryEntitySegmentResults } from '../../screening/configure/segments/segmentResultActions';
import { useQuerySegments } from '../../screening/configure/segments/segmentActions';
import { InternalApiEntityGroup, InternalApiEntityType, InternalApiSegmentResult } from '../../api-internal';
import { showFeedback } from '../../feedback/feedbackReducer';
import { useDispatch } from 'react-redux';
import { Card } from 'react-bootstrap';
import { SalvDataTag, SalvProgressCircle } from '@salvapp/ui-components';
import InternalLink from '../../common/InternalLink';
import { getSegmentPath } from '../../navigation/helper';
import { isDefined } from '../../common/helper';

interface Props {
  entityId: string;
  entityType: InternalApiEntityType;
}

const MatchingSegments = ({ entityId, entityType }: Props) => {
  const dispatch = useDispatch();
  const {
    data: segmentResults,
    isPending: isSegmentResultsPending,
    isError: isSegmentResultsError,
  } = useQueryEntitySegmentResults(entityId, entityType);
  const { data: segments, isPending: isSegmentsPending, isError: isSegmentsError } = useQuerySegments({ entityType });

  if (isSegmentResultsError || isSegmentsError) {
    dispatch(
      showFeedback({
        message: 'Could not load Matching Segments',
        success: false,
      })
    );
    return <div />;
  }

  return (
    <Card className={'person-attributes'}>
      <Card.Header>
        <h4>Matching Segments</h4>
      </Card.Header>
      <Card.Body className={'p-x-24 p-y-16'}>
        {isSegmentResultsPending || isSegmentsPending ? (
          <SalvProgressCircle />
        ) : (
          <SegmentNames segments={segments} segmentResults={segmentResults} />
        )}
      </Card.Body>
    </Card>
  );
};

interface SegmentResultsProps {
  segments: InternalApiEntityGroup[];
  segmentResults: InternalApiSegmentResult[];
}

const SegmentNames = ({ segments, segmentResults }: SegmentResultsProps) => {
  const segmentNames = segmentResults
    .map((result) => {
      const segment = segments.find((segment) => segment.versionCode === result.versionCode);
      return segment
        ? {
            name: segment.name,
            code: segment.code,
          }
        : undefined;
    })
    .filter(isDefined);
  return (
    <>
      {!segmentNames.length ? (
        'No matching Segments exist'
      ) : (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {segmentNames.map(({ name, code }, i) => (
            <span key={code} style={{ maxWidth: '600px' }}>
              <SalvDataTag key={i} label={<InternalLink title={name} link={getSegmentPath(code)} />} />
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default MatchingSegments;
